import React, { useState } from "react";
import { Link, Routes, Route } from "react-router-dom";

import MyFlights from "./components/MyFlights";
import MapView from "./components/MapView";
import FlightInfo from "./components/FlightInfo";
import logo from "./assets/flightdeck-logo-2.png";

// v1.0 has a single page (flight lookup + Santa), so the navigation is hidden.
// Flip this to true when the v2.0 pages (live flights, scheduled flights,
// airports) are ready. The links, mobile menu and routes below are kept as-is.
const SHOW_NAV = false;

// With no nav the header is just the logo, so drop its divider line, shadow and
// tinted background and let it blend into the page. Reverts with SHOW_NAV.
const SEAMLESS_HEADER = {
  borderBottom: "none",
  boxShadow: "none",
  background: "transparent",
  backdropFilter: "none",
  WebkitBackdropFilter: "none",
  position: "static",
};

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedFlightInfo, setSelectedFlightInfo] = useState(null);

  const handleFlightSelect = (flightData) => {
    setSelectedFlightInfo(flightData);
  };

  return (
    <div className="app-shell">
      <header style={SHOW_NAV ? undefined : SEAMLESS_HEADER}>
        <div className="fd-header-inner">
          {/* Brand */}
          <div className="fd-brand">
            <img src={logo} alt="flightdeck logo" className="fd-logo" />
            <span className="fd-wordmark">flightdeck</span>
          </div>

          {/* Desktop nav */}
          {SHOW_NAV && (
            <nav className="fd-nav fd-nav-desktop">
              <ul className="fd-nav-list">
                <li><Link className="fd-nav-link" to="/">Live Flights</Link></li>
                <li><Link className="fd-nav-link" to="/scheduled">Scheduled Flights</Link></li>
                <li><Link className="fd-nav-link" to="/airports">Airports</Link></li>
              </ul>
            </nav>
          )}

          {/* Mobile hamburger */}
          {SHOW_NAV && (
            <button
              className="fd-hamburger"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="Toggle menu"
            >
              <span />
              <span />
              <span />
            </button>
          )}
        </div>

        {/* Mobile menu */}
        {SHOW_NAV && menuOpen && (
          <div className="fd-mobile-menu">
            <Link to="/" onClick={() => setMenuOpen(false)}>Live Flights</Link>
            <Link to="/scheduled" onClick={() => setMenuOpen(false)}>Scheduled Flights</Link>
            <Link to="/airports" onClick={() => setMenuOpen(false)}>Airports</Link>
          </div>
        )}
      </header>

      <main>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <div className="fd-sidebar">
                  <MyFlights onFlightSelect={handleFlightSelect} />
                  <FlightInfo info={selectedFlightInfo} />
                </div>

                <div className="fd-map-column">
                  <div className="fd-map-frame">
                    <MapView selectedFlight={selectedFlightInfo} />
                  </div>
                </div>
              </>
            }
          />

          <Route
            path="/scheduled"
            element={
              <div className="fd-card">
                <h2>Scheduled Flights</h2>
                <p>Upcoming departures and arrivals.</p>
              </div>
            }
          />

          <Route
            path="/airports"
            element={
              <div className="fd-card">
                <h2>Airports</h2>
                <p>Airport boards coming soon.</p>
              </div>
            }
          />
        </Routes>
      </main>

      <footer className="fd-footer">
        <div className="fd-footer-inner">
          <span className="fd-footer-text">
            Independent flight tracking, built with ❤️
          </span>

          <p className="fd-footer-disclaimer">
            FlightDeck is a personal, non-commercial project and is under active development.
            Features and data accuracy may evolve over time. Flight information is provided
            for reference only — always verify details with the airline or airport.
          </p>

          <p className="fd-footer-support">
            If you’ve enjoyed using FlightDeck, consider supporting the project on{" "}
            <a
              href="https://ko-fi.com/flightdeck"
              target="_blank"
              rel="noopener noreferrer"
              className="fd-kofi-btn"
            >
              ☕ Ko-fi
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
